<template>
    <div class="page-container">
        <div class="page-section">
            <span>合伙人名称</span>
            <span>{{userInfo.userName}}</span>
        </div>
        <div class="page-section">
            <span>手机号码</span>
            <span>{{userInfo.mobile}}</span>
        </div>
        <!-- <div class="page-section">
            <span>交易密码</span>
            <div class="section-right">
                <span v-show="userInfo.jypwd != 1"><router-link to="/account/passwd-set" style="color:#3088F5;">去设置</router-link></span>
                <span v-show="userInfo.jypwd == 1"><router-link to="/account/passwd-update" style="color:#3088F5;">去修改</router-link></span>
                <van-icon name="arrow" color="#C8C8C8" size="18" />
            </div>
        </div> -->
        <!-- <div class="page-section">
            <span>关于我们</span>
            <van-icon name="arrow" color="#C8C8C8" size="18" />
        </div> -->
        <!-- 退出登录按钮 -->
        <div class="btn-logout" @click="logoutFlag = true">退出登录</div>
        <!-- 退出登录弹层 -->
        <van-overlay :show="logoutFlag">
            <div class="layer-wrapper" @click="logoutFlag = false">
                <div @click.stop>
                    <div class="layer-content">
                        <div class="content-title">退出登录后不会删除任何历史数据</div>
                        <div class="logout-btn" @click="logOut">退出登录</div>
                    </div>
                    <div class="btn-cancel" @click="logoutFlag = false">取消</div>
                </div>
            </div>
        </van-overlay>
    </div>
</template>
<script>
import { Icon,Overlay } from 'vant'
import $http from '@/lib/request'
import config from '@/config'
import { setLocalUserInfo } from '@/lib/util'
import {removeUid} from '@/lib/auth'

export default {
    data(){
        return {
            userInfo:{},
            logoutFlag:false
        }
    },
    components:{
        [Icon.name]:Icon,
        [Overlay.name]:Overlay
    },
    activated(){
        this.checkuData();
    },
    deactivated(){
        this.userInfo={};
        this.logoutFlag=false;
    },
    methods:{
        checkuData(){//获取最新用户信息
            $http({
                method:'post',
                url:config.api.checkUserData
            }).then(res=>{
                if(res.errno == 0){
                    this.userInfo=res.data;
                    setLocalUserInfo(res.data);
                }else{
                    Toast(res.errmsg)
                }
            })
        },
        logOut(){
            removeUid();
            this.$store.commit('removeUid');
            this.$router.replace('login');
        },
    }
}
</script>
<style lang="scss" scoped>
.page-container{
    min-height:100vh;
    box-sizing: border-box;
    padding:10px;
    background:#fafafa;
    .page-section{
        height: 44px;
        background: #FFFFFF;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 10px;
        padding:0 15px;
        font-size: 14px;
        color:#333;
        @media screen and (max-width: 750px){
            border-radius: 4px;   
        }
        .section-right{
            display: flex;
            justify-content: flex-end;
            align-items: center;
            &>span{
                font-size: 14px;
                color:#3088F5;
                line-height: 20px;
                margin-right: 5px;
            }
        }
    }
    .btn-logout{
        width: 355px;
        height: 44px;
        line-height: 44px;
        background: #FFFFFF;
        border-radius: 4px;
        text-align: center;
        color:#333;
        font-size: 14px;
        position: fixed;
        bottom:40px;
        left:50%;
        transform: translateX(-50%);
    }
    .layer-wrapper{
        display: flex;
        align-items: flex-end;
        justify-content: center;
        width: 100%;
        height: 100%;
        text-align: center;
        .layer-content{
            background:#fff;
            border-radius: 14px;
            width:355px;
            margin:0 auto;
            margin-bottom: 10px;
            .content-title{
                height:45px;
                line-height: 45px;
                font-size: 13px;
                color:#8F8F8F;
                border-bottom: 1px solid rgba(0, 0, 80, 0.05);
            }
            .logout-btn{
                height:56px;
                line-height: 56px;
                font-size: 20px;
                color:#FF3B30;
            }
        }
        .btn-cancel{
            background:#fff;
            height:56px;
            line-height: 56px;
            font-size: 20px;
            color:#007AFF;
            margin-bottom: 10px;
            border-radius: 14px;
        }
    }
}
</style>